<template>
  <div class="download_app_main">
    <div class="download_app_main__wrapper">
      <div class="download_app_main__wrapper__content-left">
        <ImageLazy
          :src="imgSrcBannerApp"
          alt="app_banner.png"
          class="do-flex download_app_main__wrapper__content-left__image-content"
        />
        <div class="download_app_main__wrapper__content-left__app-download__desktop">
          <h3 class="download_app_main__wrapper__content-left__content-desc-title">
            Download aplikasi Lion Parcel sekarang!
          </h3>
          <div class="download_app_main__wrapper__content-left__download_icon">
            <a
              class="download_app_main__wrapper__content-left__download_icon__wrap"
              :href="link.android"
              target="_blank"
            >
              <img
                id="Download_Google_Play_New"
                class="download_app_main__wrapper__content-left__download_icon__wrap__content_playstore"
                :src="PlayStore"
                alt="playStore_logo"
              >
            </a>
            <a
              class="download_app_main__wrapper__content-left__download_icon__wrap"
              :href="link.ios"
              target="_blank"
            >
              <img
                id="Download_Appstore_New"
                class="download_app_main__wrapper__content-left__download_icon__wrap__content_appstore"
                :src="AppStore"
                alt="appstore_logo"
              >
            </a>
          </div>
        </div>
      </div>
      <div class="download_app_main__wrapper__content-right">
        <div class="download_app_main__wrapper__content-right__title_content">
          Kemudahan dalam<br>genggaman
        </div>
        <div
          v-for="(item, idx) in listDesc"
          :key="idx"
          class="download_app_main__wrapper__content-right__content-desc"
        >
          <div class="download_app_main__wrapper__content-right__content-desc__list">
            <img
              :src="require(`@/assets/new-home/download-app/${item.image}.svg`)"
              class="download_app_main__wrapper__content-right__content-image"
            >
            <div>
              <div class="download_app_main__wrapper__content-right__content-desc__title">
                {{ item.title }}
              </div>
              <h2
                v-if="idx === 0 | idx === 3"
                class="download_app_main__wrapper__content-right__content-desc__subtitle"
              >
                {{ item.subtitle }}
              </h2>
              <div
                v-else
                class="download_app_main__wrapper__content-right__content-desc__subtitle"
              >
                {{ item.subtitle }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- mobile screen download app title -->
      <div class="download_app_main__wrapper__content-left__app-download__mobile">
        <h3 class="download_app_main__wrapper__content-left__content-desc-title">
          Download aplikasi Lion Parcel<br>sekarang!
        </h3>
        <div class="download_app_main__wrapper__content-left__download_icon">
          <a
            class="download_app_main__wrapper__content-left__download_icon__wrap"
            :href="link.android"
          >
            <img
              id="Download_Google_Play_New"
              class="download_app_main__wrapper__content-left__download_icon__wrap__content_playstore"
              :src="PlayStore"
              alt="playStore_logo"
            >
          </a>
          <a
            class="download_app_main__wrapper__content-left__download_icon__wrap"
            :href="link.ios"
          >
            <img
              id="Download_Appstore_New"
              class="download_app_main__wrapper__content-left__download_icon__wrap__content_appstore"
              :src="AppStore"
              alt="appstore_logo"
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlayStore from "@/assets/playstore-plain.svg";
import AppStore from "@/assets/appstore-plain.svg";
import ImageLazy from "@/components/ImageLazy/index.vue";
import BannerAppDesktop from "@/assets/new-home/download-app/download-app-banner-desktop.png";
import BannerAppMobile from "@/assets/new-home/download-app/download-app-banner-mobile.webp";

export default {
  name: "DownloadApp",
  components: {
    ImageLazy,
  },
  data() {
    return {
      PlayStore,
      AppStore,
      link: {
        android:
          "https://play.google.com/store/apps/details?id=com.lionparcel.services.consumer&hl=in",
        ios: "https://apps.apple.com/id/app/lion-parcel/id1455977134",
      },
      listDesc: [
        {
          title: "Nikmati Pick-up gratis",
          subtitle:
            "Kirim paket lebih mudah & cepat dari mana saja, kapan saja.",
          image: "pickup-icon",
        },
        {
          title: "Harga kompetitif",
          subtitle:
            "Pengiriman yang bisa diandalkan, terintegrasi dengan armada dari Lion Group.",
          image: "price-icon",
        },
        {
          title: "Fitur laporan pengiriman",
          subtitle:
            "Gak perlu ribet rekap pengirimanmu secara manual, akses langsung fitur Laporan Pengiriman.",
          image: "report-icon",
        },
        {
          title: "Kumpulkan Parcel Poin gratis",
          subtitle:
            "Tukarkan Parcel Poinmu dengan voucher ekslusif untuk belanja, makanan, game, hiburan, serta diskon kirim paket.",
          image: "point-icon",
        },
      ],
      BannerAppDesktop,
      BannerAppMobile,
    };
  },
  computed: {
    imgSrcBannerApp() {
      return this.windowWidth <= 599
        ? this.BannerAppMobile
        : this.BannerAppDesktop;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.download_app_main {
  background-color: $color-indigo-dark;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 100px;
  gap: 95px;
  margin-top: 142px;

  // @include for-size(tablet-landscape) {
  //   padding: 100px 30px;
  //   gap: 50px;
  // }

  @include for-size(tablet-portrait) {
    padding: 20px;
    gap: unset;
  }

  @include for-size(mobile) {
    margin-top: 205px;
    padding: unset;
    gap: unset;
    display: flex;
    flex-direction: column;
  }

  @include for-size(mobile-landscape) {
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 80px;
    margin-top: 205px;
  }

  &__wrapper {
    max-width: 1200px;
    display: flex;

    @include for-size(mobile) {
      max-width: unset;
      flex-direction: column;
      justify-content: center;
    }

    @include for-size(mobile-landscape) {
      max-width: unset;
      flex-direction: column;
      justify-content: center;
    }

    @media (min-width: 916px) and (max-width: 1023px) {
      max-width: unset;
      flex-direction: column;
      justify-content: center;
    }

    &__content-left {
      z-index: 999;
      height: 100%;
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      margin-right: 40px;

      @include for-size(mobile) {
        width: 100%;
      }

      @include for-size(mobile-landscape) {
        width: 100%;
      }

      @media (min-width: 916px) and (max-width: 1023px) {
        width: 100%;
      }

      &__image-content {
        margin-top: -240px;
        width: 591px;
        height: 717px;

        @include for-size(tablet-portrait) {
          margin-top: -30%;
          max-width: 320px;
          max-height: 367px;
        }

        @include for-size(mobile) {
          margin-top: -43%;
          max-width: 320px;
          max-height: 367px;
        }

        @include for-size(mobile-landscape) {
          margin-top: -25%;
        }

        @include for-size(tablet-landscape-new) {
          margin-top: -50%;
          max-width: 480px;
          max-height: 567px;
        }
      }

      &__app-download {
        @include for-size(tablet-portrait) {
          margin: -30px 0 66px 0;
        }

        @include for-size(mobile) {
          margin: 39px 0 66px 0;
        }

        @include for-size(mobile-landscape) {
          margin: 39px 0 66px 0;
        }

        &__desktop {
          text-align: center !important;
          margin-top: 50px;
          display: block;

          @include for-size(mobile) {
            display: none;
          }

          @include for-size(mobile-landscape) {
            display: none;
          }
          
          @media (min-width: 916px) and (max-width: 1023px) {
            display: none;
          }

          &__download_icon {
            margin-top: 20px;

            &__content {
              width: 130px;
              height: 42px;
            }
          }
        }

        &__mobile {
          text-align: center !important;
          display: none;

          @include for-size(mobile) {
            margin: 39px 0 66px 0;
            display: block;
          }

          @include for-size(mobile-landscape) {
            margin: 39px 0 66px 0;
            display: block;
          }

          @media (min-width: 916px) and (max-width: 1023px) {
            margin: 39px 0 66px 0;
            display: block;
          }
        }
      }

      &__download_icon {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        margin-top: 20px;

        &__wrap {
          width: 130px;
          height: 42px;
          border: 1px solid $color-border-primary;
          border-radius: 4px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;

          &__content_playstore {
            width: 114px;
            height: 24px;
          }

          &__content_appstore {
            width: 109px;
            height: 24px;
          }
        }
      }

      &__content-desc-title {
        color: $color-white;
        font-size: 24px;
        font-weight: 700;

        @include for-size(mobile) {
          font-size: 20px;
        }
      }
    }

    &__content-right {
      height: 100%;
      width: 50%;

      @include for-size(tablet-portrait) {
        padding: 0 20px;
      }

      @include for-size(mobile) {
        width: 96%;
        padding: 0 20px;
      }

      @include for-size(mobile-landscape) {
        width: 100%;
        padding: 0 20px;
      }

      @media (min-width: 916px) and (max-width: 1023px) {
        width: 100%;
        padding: 0 20px;
      }

      &__content-image {
        width: 56px;
        height: 56px;

        @include for-size(tablet-portrait) {
          width: 40px;
          height: 40px;
        }

        @include for-size(mobile) {
          width: 40px;
          height: 40px;
        }
      }

      &__title_content {
        color: $color-white;
        font-weight: 700;
        text-align: left;
        margin-bottom: 30px;
        font-size: 48px;
        line-height: 60px;

        @include for-size(tablet-portrait) {
          font-size: 24px;
          line-height: 30px;
        }

        @include for-size(mobile) {
          margin-top: 18px;
          font-size: 24px;
          line-height: 30px;
          text-align: center;
          margin-bottom: 20px;
        }

        @include for-size(mobile-landscape) {
          text-align: center;
          font-size: 48px;
          line-height: 60px;
        }
        
        @media (min-width: 916px) and (max-width: 1023px) {
          text-align: center;
          font-size: 48px;
          line-height: 60px;
        }

        @include for-size(tablet-landscape-new) {
          text-align: center;
          font-size: 34px;
          line-height: 40px;
        }
      }

      &__content-desc {
        display: flex;
        flex-direction: column;
        margin-top: 24px;
        width: 90%;

        @include for-size(tablet-portrait) {
          margin-top: 15px;
        }

        @include for-size(mobile) {
          margin-top: 18px;
          width: 100%;
        }

        @include for-size(mobile-landscape) {
          margin-top: 24px;
        }

        &__list {
          display: flex;
          align-items: start;
          gap: 16px;

          @include for-size(mobile) {
            align-items: center;
          }
        }

        &__title {
          color: $color-white;
          font-size: 24px;
          font-weight: 700;

          @include for-size(tablet-portrait) {
            font-size: 14px;
          }

          @include for-size(mobile) {
            font-size: 14px;
          }

          @include for-size(tablet-landscape-new) {
            font-size: 16px;
          }
        }

        &__subtitle {
          color: $color-gray-pensive-7;
          font-size: 20px;
          font-weight: 400;
          margin-top: 4px;
          line-height: 24px;

          @include for-size(tablet-portrait) {
            font-size: 12px;
            line-height: 15px;
          }

          @include for-size(mobile) {
            font-size: 12px;
            line-height: 15px;
          }

          @include for-size(tablet-landscape-new) {
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }
  }
}
</style>
